var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiIcon',{staticClass:"cms-html-editor-toolbar-item",class:{ 'is-active': _vm.isActive ? _vm.isActive() : null },attrs:{"title":_vm.$t(_vm.title),"value":_vm.icon},on:{"click":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }